import styled from "styled-components";
import {
  BRAND,
  GRAY_LIGHT,
  TEXT_SECONDARY,
  WHITE
} from "@streeteasy/design-system/colors";
import {
  Body,
  Caps,
  SecondaryLarge,
  SecondarySmall
} from "@streeteasy/design-system/typography";

import { smallScreen } from "src/shared/constants/screenSizes";

export const ListingCardContainer = styled.div`
  background: ${WHITE};
  border: 1px solid ${GRAY_LIGHT};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  min-height: 407px;
  position: relative;

  @media screen and (max-width: ${smallScreen}px) {
    flex-direction: row;
    flex-wrap: wrap;
    min-height: 0;
  }
`;

export const CardInfo = styled.div`
  padding-bottom: 16px;

  @media screen and (max-width: ${smallScreen}px) {
    padding-bottom: 9px;
  }
`;

export const AreaInfo = styled(Caps)`
  color: ${TEXT_SECONDARY};
  padding-right: 25px;

  @media screen and (max-width: ${smallScreen}px) {
    display: ${({ isNewDevelopment }) => (isNewDevelopment ? "none" : "block")};
  }
`;

export const Title = styled(SecondarySmall).attrs({ as: "p" })`
  color: ${BRAND};
  padding-right: 25px;

  @media screen and (max-width: ${smallScreen}px) {
    padding-right: 0;
  }
`;

export const Price = styled(SecondaryLarge).attrs({ as: "p" })`
  align-items: center;
  display: flex;
  font-size: 24px;
  font-weight: 700;

  @media screen and (max-width: ${smallScreen}px) {
    font-size: 18px;
  }
`;

export const InfoBox = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 16px 16px;
  position: relative;

  @media screen and (max-width: ${smallScreen}px) {
    justify-content: flex-start;
    height: auto;
    min-height: 125px;
    padding: 16px;
    width: 60%;
  }
`;

export const BottomBox = styled.div`
  margin-top: 16px;

  @media screen and (max-width: ${smallScreen}px) {
    margin-top: 0;
  }
`;

export const SaveButtonWrapper = styled.div`
  margin-top: calc(62% + 10px);
  position: absolute;
  right: 10px;
  top: 0;
  z-index: 10;

  @media screen and (max-width: ${smallScreen}px) {
    margin: 0;
    top: 5px;
  }
`;

export const LinkToProperty = styled.a`
  display: block;
  font-size: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 10;
`;

export const PriceDetailsContainer = styled.div`
  font-size: 14px;
  font-weight: 22px;

  @media screen and (max-width: ${smallScreen}px) {
    display: none;
  }
`;

export const NetEffectiveRent = styled(Body)``;
